export default __webpack_public_path__ + "static/media/3_banner-dev-web.b838c185.jpg";